// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AaKGH","textContainer":"styles_textContainer__jG4n_","title":"styles_title__QY1UE","gradient":"styles_gradient__AcPBY"};